export default __webpack_public_path__ + "static/media/standing-empty-log.ed2ef64d.svg";